import { createVuexTypes } from 'common/vuex-utils';

export const index = createVuexTypes({
  GET_USER_INFO: 'async',
}, 'INDEX');

export default {
  index,
};
